const portalId = process.env.REACT_APP_HUBSPOT_PORTAL_ID;
const formId = process.env.REACT_APP_HUBSPOT_FORM_ID;

export async function submitToHubSpot(fields, context = {}) {
  if (!portalId || !formId) {
    console.warn("[HubSpot] Environment variables not configured");
    return {
      success: false,
      error: "HubSpot not configured",
      skipped: true,
    };
  }

  const formData = {
    fields,
    context: {
      pageUri: window.location.href,
      pageName: context.pageName || "Marketing Plan Generator",
      ...context,
    },
    legalConsentOptions: {
      consent: {
        consentToProcess: true,
        text: "I agree to allow Hububble to store and process my personal data.",
        communications: [
          {
            value: true,
            subscriptionTypeId: 999,
            text: "I agree to receive marketing communications from Hububble.",
          },
        ],
      },
    },
  };

  try {
    const response = await fetch(
      `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HubSpot API error: ${response.status} - ${errorText}`);
    }

    const data = await response.json();

    return {
      success: true,
      data,
    };
  } catch (error) {
    console.error("[HubSpot] Submission failed:", error);
    return {
      success: false,
      error: error.message,
    };
  }
}

function formatDateForHubSpot(date) {
  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Taipei",
    timeZoneName: "short",
  });
}

export function getSessionProperties(sessionCode, status = "Incomplete") {
  const baseUrl = process.env.REACT_APP_BASE_URL || window.location.origin;
  const now = new Date();
  const expirationDate = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);

  const isCompleted = status === "Completed";
  const sessionUrl = isCompleted
    ? `${baseUrl}/complete?session=${sessionCode}`
    : `${baseUrl}/form/name-success?session=${sessionCode}`;

  return {
    hb_mpg_result_url: sessionUrl,
    hb_mpg_result_session_creation: formatDateForHubSpot(now),
    hb_mpg_result_session_expiration: formatDateForHubSpot(expirationDate),
    hb_mpg_result_session_status: status,
  };
}

export function mapFormDataToHubSpotFields(sessionData, contactData) {
  const { responses } = sessionData;

  return {
    firstname: contactData.firstname,
    lastname: contactData.lastname,
    email: contactData.email,
    company: contactData.company,
    industry: contactData.industry,
    numemployees: contactData.numemployees,

    primary_marketing_channels:
      responses?.q4_marketing_channels?.channels?.join(";") || "",
    primary_marketing_channels_other:
      responses?.q4_marketing_channels?.other || "",

    nurturing_approach: responses?.q5_nurturing?.approach || "",

    marketing_staffing: responses?.q6_staffing?.staffing || "",

    marketing_capabilities:
      responses?.q7_capabilities?.capabilities?.join(";") || "",

    top_3_marketing_goals: responses?.q8_goals?.goals?.join(";") || "",

    marketing_pain_points:
      responses?.q9_pain_points?.painPoints?.join(";") || "",
  };
}

export function formatFieldsForHubSpot(dataObject) {
  return Object.entries(dataObject).map(([name, value]) => ({
    name,
    value: value === null || value === undefined ? "" : String(value),
  }));
}
